module.exports = {
    name:      "humpyhobby",
    buildDate: "Mon Apr 09 2018 12:59:21 GMT+0000 (UTC)",
    version:   "1.0.0",
    build:     "70.1672 debug"
};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 10
// module chunks = 0